import { render, staticRenderFns } from "./write.vue?vue&type=template&id=3d81f36b&scoped=true"
import script from "./write.vue?vue&type=script&lang=js"
export * from "./write.vue?vue&type=script&lang=js"
import style0 from "./write.vue?vue&type=style&index=0&id=3d81f36b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d81f36b",
  null
  
)

export default component.exports